<script lang="ts">
  import { setCommonTranslationsContext } from '@athena-lib/commonTranslationsContext';
  import type { Snippet } from 'svelte';

  type WithTranslationsProps = {
    translations: Record<string, string>;
    children: Snippet;
  };

  const { children, translations }: WithTranslationsProps = $props();

  setCommonTranslationsContext(translations);
</script>

{@render children()}
